import { useEffect, useState } from "react"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { SplitButton } from "../../../../../shared/components/buttons/SplitButton"
import { TranslationKey } from "../../../../localization/translations"
import { MerchantArticleStatus } from "../merchantNewsItemType"

enum SplitButtonLabel {
    CREATE_DRAFT = "CREATE_DRAFT",
    PUBLISH = "PUBLISH",
    SAVE = "SAVE",
    UNPUBLISH = "UNPUBLISH", // draft
    CANCEL_PUBLICATION = "CANCEL_PUBLICATION", // draft
    REPUBLISH = "REPUBLISH", // published
}
const labelMappings: Record<MerchantArticleStatus, TranslationKey> = {
    [MerchantArticleStatus.DRAFT]: "create-and-publish-split-button-create-draft",
    [MerchantArticleStatus.PUBLISHED]: "create-and-publish-split-button-publish",
    [MerchantArticleStatus.SCHEDULED]: "create-and-publish-split-button-save",
    [MerchantArticleStatus.EXPIRED]: "create-and-publish-split-button-save",
}

const statusOptions = {
    [MerchantArticleStatus.DRAFT]: [SplitButtonLabel.CREATE_DRAFT, SplitButtonLabel.PUBLISH],
    [MerchantArticleStatus.PUBLISHED]: [SplitButtonLabel.PUBLISH, SplitButtonLabel.UNPUBLISH],
    [MerchantArticleStatus.SCHEDULED]: [SplitButtonLabel.SAVE, SplitButtonLabel.CANCEL_PUBLICATION],
    [MerchantArticleStatus.EXPIRED]: [SplitButtonLabel.SAVE, SplitButtonLabel.REPUBLISH],
}

const statusMapping = {
    [SplitButtonLabel.CREATE_DRAFT]: MerchantArticleStatus.DRAFT,
    [SplitButtonLabel.PUBLISH]: MerchantArticleStatus.PUBLISHED,
    [SplitButtonLabel.UNPUBLISH]: MerchantArticleStatus.DRAFT,
    [SplitButtonLabel.SAVE]: undefined, // SAVE does not change the status, only submits form
    [SplitButtonLabel.CANCEL_PUBLICATION]: MerchantArticleStatus.DRAFT,
    [SplitButtonLabel.REPUBLISH]: MerchantArticleStatus.PUBLISHED,
}
type CreateAndPublishSplitButtonProps = Readonly<{
    handleClick: () => void
    status: MerchantArticleStatus
    setStatus: React.Dispatch<React.SetStateAction<MerchantArticleStatus>>
}>

export function CreateAndPublishSplitButton({ handleClick, status, setStatus }: CreateAndPublishSplitButtonProps) {
    const [label, setLabel] = useState<TranslationKey>()
    const { l10n } = useAppLocalization()

    useEffect(() => {
        setLabel(labelMappings[status])
    }, [status])

    const buttonOptions = statusOptions[status] || []

    const handleSelect = (actionKey: string) => {
        const newStatus = statusMapping[actionKey as SplitButtonLabel]
        if (newStatus) {
            setStatus(newStatus)
        }
        handleClick()
    }

    return (
        <SplitButton
            options={buttonOptions}
            optionBase="create-and-publish-split-button"
            onSelect={handleSelect}
            buttonLabel={l10n.getString(label ?? "create-and-publish-split-button-save")}
            isFullWidth
        />
    )
}
